<template>
  <!-- 하드웨어 정보 -->
    <div>
      <el-row type="flex" class="title-bar" justify="space-between">
        <div class="title-h3">하드웨어 정보</div>
        <div>
          최근 수집시간 : <em>{{hardwareCheckDatatime}}</em>
          <el-button class="cmp-margin-left" size="small" @click="reloadHardwareInfo()" type="primary">하드웨어 정보 갱신</el-button>
          <el-button size="small" @click="exportHardwareInfo"><img src="@/assets/img/icons/excel.png" style="position:relative;top:3px;left:-2px"> 엑셀출력</el-button>
        </div>
      </el-row>
      <hr class="mr-b20">
      <!-- CPU -->
      <el-row class="title-bar" type="flex" justify="space-between">
        <div>
          <div class="title-h4 tit">CPU 정보</div>
        </div>
        <div>
          <w-header-search-button @click="cpuShowSearchTool = !cpuShowSearchTool"></w-header-search-button>
        </div>
      </el-row>
      <el-table-wrapper :data="dataList.CPU" :column-default="columnDefault" :columns="cpuColumns" :pagination="false" :show-custom-header="true" :show-search-tool="cpuShowSearchTool" class="mr-b20" style="width:100%;">
      </el-table-wrapper>
      <!-- 메모리 -->
      <el-row class="title-bar" type="flex" justify="space-between">
        <div>
          <div class="title-h4 tit">메모리 정보</div>
        </div>
        <div>
          <w-header-search-button @click="memShowSearchTool = !memShowSearchTool"></w-header-search-button>
        </div>
      </el-row>
      <el-table-wrapper :data="dataList.MEMORY" :column-default="columnDefault" :columns="memColumns" :pagination="false" :show-custom-header="true" :show-search-tool="memShowSearchTool" class="mr-b20" style="width:100%;">
      </el-table-wrapper>
      <!-- 디스크 -->
      <el-row class="title-bar" type="flex" justify="space-between">
        <div>
          <div class="title-h4 tit">디스크 정보</div>
        </div>
        <div>
          <w-header-search-button @click="diskShowSearchTool = !diskShowSearchTool"></w-header-search-button>
        </div>
      </el-row>
      <el-table-wrapper :data="dataList.DISK" :column-default="columnDefault" :columns="diskColumns" :pagination="false" :show-custom-header="true" :show-search-tool="diskShowSearchTool" class="mr-b20" style="width:100%;">
      </el-table-wrapper>
      <!-- NIC -->
      <el-row class="title-bar" type="flex" justify="space-between">
        <div>
          <div class="title-h4 tit">NIC 정보</div>
        </div>
        <div>
          <w-header-search-button @click="nicShowSearchTool = !nicShowSearchTool"></w-header-search-button>
        </div>
      </el-row>
      <el-table-wrapper :data="dataList.NETWORK" :column-default="columnDefault" :columns="nicColumns" :pagination="false" :show-custom-header="true" :show-search-tool="nicShowSearchTool" style="width:100%;">
      </el-table-wrapper>
    </div>
</template>

<script>
import moment from 'moment';
import { mapGetters } from 'vuex';
import { isNil, eq } from 'lodash';
import { columnDefault } from '@/constants/table';
import msgUtil from '@/utils/message';
import { EMPTY_TEXT, getValueAfterCheckEmpty } from '@/utils/string';
import { convertValuByUnit } from '@/utils/number';
import serverInfoAPI from '@/api/config/server/server-info';

export default {
  name: 'WHardwareInfoNode',
  props: {
    activeTab: {
      type: String,
    },
    nodeParams: {
      type: Object,
    },
  },
  data() {
    return {
      columnDefault,
      hardwareCheckDatatime: null,
      cpuShowSearchTool: false,
      memShowSearchTool: false,
      diskShowSearchTool: false,
      nicShowSearchTool: false,
      wmiClassNameList: ['CPU', 'MEMORY', 'DISK', 'NETWORK'],
      params: {
        objId: null,
        ciInstanceId: null,
        wmiClassName: null,
      },
      dataList: {
        CPU: null,
        MEMORY: null,
        DISK: null,
        NETWORK: null,
      },
      cpuColumns: [
        {
          type: 'index',
          width: '50',
        },
        {
          prop: 'NumberOfCores',
          label: '코어 수',
          width: 200,
          sortable: true,
          searchable: false,
          formatter: this.getTableValueAfterCheckEmpty,
        },
        {
          prop: 'NumberOfLogicalProcessors',
          label: '논리 프로세서 수',
          width: 200,
          sortable: true,
          searchable: false,
          formatter: this.getTableValueAfterCheckEmpty,
        },
        {
          prop: 'Description',
          label: '설명',
          sortable: true,
          searchable: true,
          formatter: this.getTableValueAfterCheckEmpty,
        },
        {
          prop: 'L2CacheSize',
          label: 'L2 캐쉬',
          width: 200,
          sortable: true,
          searchable: false,
          formatter: this.getTableValueAfterCheckEmpty,
        },
        {
          prop: 'L3CacheSize',
          label: 'L3 캐쉬',
          width: 200,
          sortable: true,
          searchable: false,
          formatter: this.getTableValueAfterCheckEmpty,
        },
        {
          prop: 'MaxClockSpeed',
          label: '최대 클럭 속도',
          width: 200,
          sortable: true,
          searchable: false,
          formatter: this.convertValue,
        },
      ],
      memColumns: [
        {
          type: 'index',
          width: '50',
        },
        {
          prop: 'Capacity',
          label: '크기',
          sortable: true,
          searchable: false,
          formatter: this.getConvertMemorySize,
        },
        {
          prop: 'Speed',
          label: '속도',
          sortable: true,
          searchable: false,
          formatter: this.getTableValueAfterCheckEmpty,
        },
        {
          prop: 'DeviceLocator',
          label: '장착 슬롯',
          sortable: true,
          searchable: true,
          formatter: this.getTableValueAfterCheckEmpty,
        },
        {
          prop: 'Manufacturer',
          label: '제조사',
          sortable: true,
          searchable: true,
          formatter: this.getTableValueAfterCheckEmpty,
        },
        {
          prop: 'SerialNumber',
          label: '시리얼 번호',
          sortable: true,
          searchable: true,
          formatter: this.getTableValueAfterCheckEmpty,
        },
      ],
      diskColumns: [
        {
          type: 'index',
          width: '50',
        },
        {
          prop: 'Size',
          label: '크기',
          sortable: true,
          searchable: false,
          formatter: this.getConvertSizeByMData,
        },
        {
          prop: 'Model',
          label: '모델명',
          sortable: true,
          searchable: true,
          formatter: this.getTableValueAfterCheckEmpty,
        },
        {
          prop: 'InterfaceType',
          label: '종류',
          sortable: true,
          searchable: true,
          formatter: this.getTableValueAfterCheckEmpty,
        },
        {
          prop: 'SerialNumber',
          label: '시리얼 번호',
          sortable: true,
          searchable: true,
          formatter: this.getTableValueAfterCheckEmpty,
        },
      ],
      nicColumns: [
        {
          type: 'index',
          width: '50',
        },
        {
          prop: 'Status',
          label: '상태',
          sortable: true,
          searchable: true,
          formatter: this.getStatusConvert,
        },
        {
          prop: 'Speed',
          label: '속도',
          sortable: true,
          searchable: false,
          formatter: this.getConvertSizeByBData,
        },
        {
          prop: 'Description',
          label: '설명',
          sortable: true,
          searchable: true,
          formatter: this.getTableValueAfterCheckEmpty,
        },
        {
          prop: 'MACAddress',
          label: 'MAC 주소',
          sortable: true,
          searchable: true,
          formatter: this.getTableValueAfterCheckEmpty,
        },
        {
          prop: 'AdapterType',
          label: '종류',
          sortable: true,
          searchable: true,
          formatter: this.getTableValueAfterCheckEmpty,
        },
        {
          prop: 'IpAddress4',
          label: 'IPv4 주소',
          sortable: true,
          searchable: true,
          formatter: this.getTableValueAfterCheckEmpty,
        },
        {
          prop: 'IpAddress6',
          label: 'IPv6 주소',
          sortable: true,
          searchable: true,
          formatter: this.getTableValueAfterCheckEmpty,
        },
        {
          prop: 'Subnet',
          label: '서브넷',
          sortable: true,
          searchable: true,
          formatter: this.getTableValueAfterCheckEmpty,
        },
        {
          prop: 'Gateway',
          label: '게이트웨이',
          sortable: true,
          searchable: true,
          formatter: this.getTableValueAfterCheckEmpty,
        },
      ],
    };
  },
  computed: mapGetters(['selectedNode']),
  watch: {
    activeTab: {
      handler() {
        this.params.objId = this.nodeParams.objId;
        this.params.ciInstanceId = this.nodeParams.ciInstanceId;
        this.loadStore();
      },
    },
    nodeParams: {
      handler() {
        this.params.objId = this.nodeParams.objId;
        this.params.ciInstanceId = this.nodeParams.ciInstanceId;
        this.loadStore();
      },
      immediate: true,
    },
  },
  methods: {
    /**
     * [reloadHardwareInfo 서버 하드웨어 정보 갱신]
     * @author yelim
     * @return {[type]}
     */
    reloadHardwareInfo() {
      const me = this;
      if (!isNil(this.nodeParams)) {
        const hardwareObj = {
          objId: this.nodeParams.objId,
          ciInstanceId: this.nodeParams.ciInstanceId,
          ipaddressApplytype: this.nodeParams.ipaddressApplytype,
        };
        if (!isNil(this.nodeParams.ipaddressIpv4)) {
          hardwareObj.ipaddressIpv4 = this.nodeParams.ipaddressIpv4;
        }
        if (!isNil(this.nodeParams.ipaddressIpv6)) {
          hardwareObj.ipaddressIpv6 = this.nodeParams.ipaddressIpv6;
        }
        const target = '하드웨어 정보 갱신';
        const action = msgUtil.action.RUN;
        serverInfoAPI.executeHardwareLoad(hardwareObj).then((response) => {
          if (response.data.success) {
            this.$message(msgUtil.getResultMsgData(action, target, true));
            me.loadStore();
          } else {
            this.$message(msgUtil.getResultMsgData(action, target, false));
          }
        }).catch(() => {
          this.$message(msgUtil.getResultMsgData(action, target, false));
        });
      }
    },
    loadStore() {
      const me = this;
      if (!isNil(this.params.objId) && this.activeTab === this.$options.name) {
        serverInfoAPI.getHardwareInfoList(this.params).then((response) => {
          if (response.data.success) {
            me.dataList.CPU = response.data.data.CPU;
            me.dataList.DISK = response.data.data.DISK;
            me.dataList.MEMORY = response.data.data.MEMORY;
            me.dataList.NETWORK = response.data.data.NETWORK;
            me.hardwareCheckDatatime = this.checkDatetimeFormatter(response.data.data.checkDatetime);
          }
        });
      }
    },
    /**
     * [getConvertSizeByMData DISK 목록의 디스크 크기 포매터]
     * WINDOW일 경우 null, 나머지 MB단위로 변환
     * @author yelim
     */
    getConvertSizeByMData(row, column, value) {
      let unit = 'MB';
      if (row.objtypeId === 'WINSVR') {
        unit = 'Byte';
      }
      const convertSize = convertValuByUnit(value, unit, true, false, true);
      return `${convertSize}B`;
    },
    /**
     * [getConvertMemorySize Memory 목록의 메모리 크기 포매터]
     * @author yelim
     */
    getConvertMemorySize(row, column, value) {
      const memSize = parseFloat(value);
      let memUnit = 'Byte';
      if (row.objtypeId === 'WINSVR') {
        memUnit = 'Byte';
      } else if (memSize >= 1024) {
        memUnit = value.substring(value.length - 2, value.length);
      } else {
        memUnit = 'MB';
      }
      return `${convertValuByUnit(memSize, memUnit, true, false, true)}B`;
    },
    getConvertSizeByBData(row, column, value) {
      return convertValuByUnit(value);
    },
    getTableValueAfterCheckEmpty(row, column, value) {
      const checkValue = value;
      if (typeof (value) === 'string') {
        if (checkValue.toString().toLowerCase() === 'unknown' || checkValue.toString().toLowerCase() === 'not specified') {
          return EMPTY_TEXT;
        }
      }
      return getValueAfterCheckEmpty(value);
    },
    getStatusConvert(row, column, value) {
      if (row.objtypeId === 'WINSVR') {
        if (eq(value, 'TRUE')) {
          return 'UP';
        } else if (eq(value, 'FALSE')) {
          return 'DOWN';
        }
        return EMPTY_TEXT;
      }
      return value;
    },
    exportHardwareInfo() {
      if (!isNil(this.params.objId) && !isNil(this.params.ciInstanceId)) {
        serverInfoAPI.exportHardwareInfoList(this.params);
      }
    },
    checkDatetimeFormatter(value) {
      return isNil(value) ? EMPTY_TEXT : moment(new Date(value)).format('YYYY-MM-DD HH:mm:ss');
    },
  },
};
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/views/config/node/server/hardware/index.vue